!(function() {
  if (typeof document === 'undefined') {
    return
  }

  require('./modules/sp_popup')
}())
